<template>
    <div>
        <div class="security-title">{{ $t('ActionTrailSecurity.title') }}</div>
        <div class="security-top">
            <security-search></security-search>
        </div>
        <table-security></table-security>
    </div>
</template>

<script>
    import SecuritySearch from '../security/SecuritySearch'
    import TableSecurity from '../security/TableSecurity'

    export default {
        name: 'Security',
        components: {
            SecuritySearch,
            TableSecurity
        }
    }
</script>

<style scoped>
    .security-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
    }
    .security-top
    {
        width: 100%;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/security/Security.vue